export default __webpack_public_path__ + "static/media/cv_ac.d10eb5fe.svg";